import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import React from 'react';
import { PROGRAMMING_PAGE } from '../../../utils/constants';
import { IconArrowRightTeal2, getIcon } from '../../Icons';
import NestedPage from '../NestedPage';
import './NestedPages.scss';

interface NestedPagesProps {
  children: {
    edges: Array<any>;
  };
  acceptedLength?: number;
}

export default function NestedPages({ children }: NestedPagesProps): React.ReactElement {
  const location = useLocation();
  return (
    <div className="nested-pages">
      {children?.edges?.map((page, i) => {
        const parts = page.node.relativeDirectory.split('/');
        // Build columns Title
        if (parts.length !== 2) {
          return null;
        }

        return (
          <div className="nested-pages__section" id={page.node.name} key={page.node.relativeDirectory}>
            <h2>
              {page.node.childMdx.frontmatter.icon && getIcon(page.node.childMdx.frontmatter.icon)}
              {page.node.childMdx.frontmatter.title}
            </h2>
            {location.pathname === PROGRAMMING_PAGE ? (
              <div className="nested-pages__articles">
                {page.node.childMdx.frontmatter.links?.map((link) => {
                  return (
                    <div className={'nested-page'} key={link.url}>
                      <Link to={link.url}>
                        <div className="nested-page__title">{link.title}</div>
                      </Link>
                    </div>
                  );
                })}
                <a
                  href={page.node.childMdx.frontmatter.url}
                  className="nested-pages__links"
                  target={page.node.childMdx.frontmatter.external ? '_blank' : null}
                  rel="noreferrer"
                >
                  view all <IconArrowRightTeal2 className="nested-pages__icon" />
                </a>
              </div>
            ) : (
              <div className="nested-pages__articles">
                {children.edges.map((childPage) => {
                  if (
                    page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
                    childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
                  ) {
                    return null;
                  }

                  return <NestedPage key={`${i}-${childPage.node.fields.slug}`}>{childPage}</NestedPage>;
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
